var alignContentMap = {
  'flex-start': 'content-start',
  'flex-end': 'content-end',
  center: 'content-center',
  'space-between': 'content-between',
  'space-around': 'content-around',
  'space-evenly': 'content-evenly',
  baseline: 'content-baseline'
};
var floatMap = {
  left: 'float-left',
  right: 'float-right',
  none: 'float-none'
};
var cursorMap = {
  auto: 'cursor-auto',
  default: 'cursor-default',
  pointer: 'cursor-pointer',
  text: 'cursor-text',
  'not-allowed': 'cursor-not-allowed'
};
var alignItemsMap = {
  start: 'items-start',
  end: 'items-end',
  center: 'items-center',
  'flex-start': 'items-start',
  'flex-end': 'items-end',
  baseline: 'items-baseline',
  stretch: 'items-stretch'
};
var alignSelfMap = {
  auto: 'self-auto',
  start: 'self-start',
  end: 'self-end',
  'flex-start': 'self-start',
  'flex-end': 'self-end',
  center: 'self-center',
  baseline: 'self-baseline',
  stretch: 'self-stretch'
};
var borderStyleMap = {
  solid: 'border-solid',
  dashed: 'border-dashed',
  dotted: 'border-dotted',
  none: 'border-none'
};
var boxSizingMap = {
  'border-box': 'box-border',
  'content-box': 'box-content'
};
var displayMap = {
  none: 'hidden',
  block: 'block',
  'inline-block': 'inline-block',
  inline: 'inline',
  flex: 'flex',
  'inline-flex': 'inline-flex',
  table: 'table',
  'inline-table': 'inline-table',
  'table-caption': 'table-caption',
  'table-cell': 'table-cell',
  'table-column': 'table-column',
  'table-column-group': 'table-column-group',
  'table-row': 'table-row',
  'table-row-group': 'table-row-group',
  contents: 'contents',
  grid: 'grid'
};
var flexDirectionMap = {
  row: 'flex-row',
  'row-reverse': 'flex-row-reverse',
  column: 'flex-col',
  'column-reverse': 'flex-col-reverse'
};
var flexMap = {
  '0': 'flex-[0_1_0%]',
  '1': 'flex-1',
  '2': 'flex-[2_1_0%]',
  '3': 'flex-[3_1_0%]',
  '4': 'flex-[4_1_0%]',
  '5': 'flex-[5_1_0%]',
  '6': 'flex-[6_1_0%]',
  '7': 'flex-[7_1_0%]',
  '8': 'flex-[8_1_0%]',
  '9': 'flex-[9_1_0%]',
  '10': 'flex-[10_1_0%]',
  '11': 'flex-[11_1_0%]',
  '12': 'flex-[12_1_0%]',
  auto: 'flex-auto',
  initial: 'flex-initial',
  none: 'flex-none'
};
var flexGrowMap = {
  '0': 'grow-0',
  '1': 'grow',
  '2': 'grow-[2]',
  '3': 'grow-[3]',
  '4': 'grow-[4]',
  '5': 'grow-[5]',
  '6': 'grow-[6]',
  '7': 'grow-[7]',
  '8': 'grow-[8]',
  '9': 'grow-[9]',
  '10': 'grow-[10]',
  '11': 'grow-[11]',
  '12': 'grow-[12]'
};
var flexShrinkMap = {
  '0': 'shrink-0',
  '1': 'shrink',
  '2': 'shrink-[2]',
  '3': 'shrink-[3]',
  '4': 'shrink-[4]',
  '5': 'shrink-[5]',
  '6': 'shrink-[6]',
  '7': 'shrink-[7]',
  '8': 'shrink-[8]',
  '9': 'shrink-[9]',
  '10': 'shrink-[10]',
  '11': 'shrink-[11]',
  '12': 'shrink-[12]'
};
var flexWrapMap = {
  nowrap: 'flex-nowrap',
  wrap: 'flex-wrap',
  'wrap-reverse': 'flex-wrap-reverse'
};
var gridAutoColumnsMap = {
  auto: 'auto-cols-auto',
  'min-content': 'auto-cols-min',
  'max-content': 'auto-cols-max',
  'minmax(0, 1fr)': 'auto-cols-fr'
};
var gridAutoFlowMap = {
  row: 'grid-flow-row',
  column: 'grid-flow-col',
  dense: 'grid-flow-dense',
  'row dense': 'grid-flow-row-dense',
  'column dense': 'grid-flow-col-dense'
};
var gridAutoRowsMap = {
  auto: 'auto-rows-auto',
  'min-content': 'auto-rows-min',
  'max-content': 'auto-rows-max',
  'minmax(0, 1fr)': 'auto-rows-fr'
};
var justifyContentMap = {
  start: 'justify-start',
  end: 'justify-end',
  'flex-start': 'justify-start',
  'flex-end': 'justify-end',
  center: 'justify-center',
  'space-between': 'justify-between',
  'space-around': 'justify-around',
  'space-evenly': 'justify-evenly'
};
var listStyleMap = {
  none: 'list-none',
  disc: 'list-disc',
  decimal: 'list-decimal'
};
var outlineStyleMap = {
  solid: 'outline',
  dashed: 'outline-dashed',
  dotted: 'outline-dotted',
  none: 'outline-none'
};
var overflowMap = {
  auto: 'overflow-auto',
  hidden: 'overflow-hidden',
  clip: 'overflow-clip',
  visible: 'overflow-visible',
  scroll: 'overflow-scroll'
};
var overflowXMap = {
  auto: 'overflow-x-auto',
  hidden: 'overflow-x-hidden',
  clip: 'overflow-x-clip',
  visible: 'overflow-x-visible',
  scroll: 'overflow-x-scroll'
};
var overflowYMap = {
  auto: 'overflow-y-auto',
  hidden: 'overflow-y-hidden',
  clip: 'overflow-y-clip',
  visible: 'overflow-y-visible',
  scroll: 'overflow-y-scroll'
};
var overflowScrollingMap = {
  auto: 'scrolling-auto',
  touch: 'scrolling-touch'
};
var pointerEventsMap = {
  none: 'pointer-events-none',
  auto: 'pointer-events-auto'
};
var positionMap = {
  static: 'static',
  fixed: 'fixed',
  absolute: 'absolute',
  relative: 'relative',
  sticky: 'sticky'
};
var scrollSnapAlignMap = {
  start: 'snap-start',
  end: 'snap-end',
  center: 'snap-center',
  none: 'snap-align-none'
};
var scrollSnapStopMap = {
  normal: 'snap-normal',
  always: 'snap-always'
};
var scrollSnapTypeMap = {
  none: 'snap-none',
  mandatory: 'snap-mandatory',
  proximity: 'snap-proximity'
};
var scrollSnapMap = {
  none: undefined,
  mandatory: 'snap-x',
  proximity: 'snap-x'
};
var textAlignMap = {
  left: 'text-left',
  right: 'text-right',
  center: 'text-center',
  justify: 'text-justify',
  start: 'text-start',
  end: 'text-end'
};
var textDecorationMap = {
  underline: 'underline',
  overline: 'overline',
  'line-through': 'line-through',
  'no-underline': 'no-underline',
  none: 'no-underline'
};

// Use this mapper when Typography uses Box CSS
var textDecorationStyleMap = {
  solid: 'decoration-solid',
  double: 'decoration-double',
  dotted: 'decoration-dotted',
  dashed: 'decoration-dashed',
  wavy: 'decoration-wavy'
};
var textOverflowMap = {
  ellipsis: 'text-ellipsis',
  clip: 'text-clip'
};
var userSelectMap = {
  none: 'select-none',
  text: 'select-text',
  all: 'select-all',
  auto: 'select-auto'
};
var verticalAlignMap = {
  baseline: 'align-baseline',
  top: 'align-top',
  middle: 'align-middle',
  bottom: 'align-bottom',
  'text-top': 'align-text-top',
  'text-bottom': 'align-text-bottom',
  sub: 'align-sub',
  super: 'align-super'
};
var visibilityMap = {
  visible: 'visible',
  hidden: 'invisible',
  collapse: 'collapse'
};
var whiteSpaceMap = {
  normal: 'whitespace-normal',
  nowrap: 'whitespace-nowrap',
  pre: 'whitespace-pre',
  'pre-line': 'whitespace-pre-line',
  'pre-wrap': 'whitespace-pre-wrap'
};
var wordBreakMap = {
  normal: 'break-normal',
  'break-all': 'break-all'
};
var touchActionMap = {
  auto: 'touch-auto',
  none: 'touch-none',
  'pan-down': 'touch-pan-down',
  'pan-left': 'touch-pan-left',
  'pan-right': 'touch-pan-right',
  'pan-up': 'touch-pan-up',
  'pan-x': 'touch-pan-x',
  'pan-y': 'touch-pan-y',
  'pinch-zoom': 'touch-pinch-zoom',
  manipulation: 'touch-manipulation'
};
var textDecorationLineMap = {
  underline: 'underline',
  overline: 'overline',
  none: 'no-underline',
  'line-through': 'line-through'
};
var allMap = {
  inherit: 'all-inherit',
  initial: 'all-initial',
  unset: 'all-unset',
  revert: 'all-revert'
};
var fontStyleMap = {
  italic: 'font-style-italic',
  normal: 'font-style-normal'
};
var appearanceMap = {
  none: 'appearance-none',
  auto: 'appearance-auto'
};

export { alignContentMap, alignItemsMap, alignSelfMap, allMap, appearanceMap, borderStyleMap, boxSizingMap, cursorMap, displayMap, flexDirectionMap, flexGrowMap, flexMap, flexShrinkMap, flexWrapMap, floatMap, fontStyleMap, gridAutoColumnsMap, gridAutoFlowMap, gridAutoRowsMap, justifyContentMap, listStyleMap, outlineStyleMap, overflowMap, overflowScrollingMap, overflowXMap, overflowYMap, pointerEventsMap, positionMap, scrollSnapAlignMap, scrollSnapMap, scrollSnapStopMap, scrollSnapTypeMap, textAlignMap, textDecorationLineMap, textDecorationMap, textDecorationStyleMap, textOverflowMap, touchActionMap, userSelectMap, verticalAlignMap, visibilityMap, whiteSpaceMap, wordBreakMap };
//# sourceMappingURL=mappers.mappings.js.map
